import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";

const linkBase =
  "px-3 py-2 rounded-full text-sm font-semibold hover:bg-white hover:text-black transition";
const linkActive = "bg-white text-black";

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);
  useEffect(() => {
    const onLangChange = () => setOpen(false);
    i18n.on("languageChanged", onLangChange);
    return () => i18n.off("languageChanged", onLangChange);
  }, [i18n]);

  const navItems = [
    { to: "/", label: t("nav.home"), end: true },
    { to: "/services", label: t("nav.services"), end: true },
    { to: "/about", label: t("nav.about") },
    { to: "/team", label: t("nav.team") },
    /*
    { to: "/contact", label: t("nav.contact") },
     */
  ];

  return (
    <nav className="relative border-b border-neutral-800 sticky top-0 z-40 bg-transparent backdrop-blur-md">
      <div className="nav-overlay"><div className="nav-grid" /></div>

      <div className="max-w-5xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img src="/logo.png" alt="2Getters" className="h-14 w-auto select-none" draggable="false" />
        </Link>

        <div className="hidden md:flex items-center gap-2">
          {navItems.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`}
            >
              {label}
            </NavLink>
          ))}
          <div className="ml-2"><LanguageSwitcher /></div>
        </div>

        <button
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen(v => !v)}
          className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-xl border border-neutral-700"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" className="text-white" aria-hidden="true">
            {open ? (
              <path fill="currentColor" d="M18.3 5.71L12 12l6.3 6.29-1.41 1.42L10.59 13.4l-6.3 6.3-1.41-1.42L9.17 12 1.88 4.71 3.3 3.29l6.3 6.3 6.29-6.3z" />
            ) : (
              <path fill="currentColor" d="M3 6h18v2H3V6zm0 5h18v2H3v-2zm0 5h18v2H3v-2z" />
            )}
          </svg>
        </button>
      </div>
      
      <div className={`${open ? "block" : "hidden"} md:hidden border-top border-neutral-800`}>
        <div className="max-w-5xl mx-auto px-4 py-3">
          <div className="flex flex-col gap-2">
            {navItems.map(({ to, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `w-full text-left ${linkBase} ${isActive ? linkActive : "border border-neutral-800"}`
                }
              >
                {label}
              </NavLink>
            ))}
            <div className="pt-2"><LanguageSwitcher /></div>
          </div>
        </div>
      </div>
    </nav>
  );
}
